var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "black",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 3C17.2209 3 21.25 7.02908 21.25 12C21.25 16.9709 17.2209 21 12.25 21M12.25 3C14.1006 3 15.5996 7.02908 15.5996 12C15.5996 16.9709 14.1006 21 12.25 21M12.25 3C10.3994 3 8.89972 7.02908 8.89972 12C8.89972 14.329 9.22886 16.4513 9.76905 18.0493M12.25 21C7.27908 21 3.25 16.9709 3.25 12C3.25 8.58793 5.14831 5.61962 7.94651 4.09347M21.25 11.9974C21.25 13.848 17.2209 15.3474 12.25 15.3474C7.27908 15.3474 3.25 13.848 3.25 11.9974C3.25 10.1468 7.27908 8.64746 12.25 8.64746C14.5915 8.64746 16.7241 8.98014 18.325 9.5255",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.50c59834eb6681e507a2e603728d282d.svg";
export { ForwardRef as ReactComponent };